import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import dayjs from "dayjs"
import {
    isTodayBeforeDate,
    useAssignFailedReservations
} from "../../hooks/useReservation"

export const useUnassignedAlertCount = (token: string) => {
    const [count, setCount] = useState(0)
    const { data, refetch } = useAssignFailedReservations(token, {})

    useEffect(() => {
        setCount(
            data?.filter(r => isTodayBeforeDate(dayjs(r.staySpan.endDate)))
                .length ?? 0
        )
    }, [data])

    // locationが変更されるたびにカウントを更新する
    // 予約を割り当てしただけではカウントが更新されないが労力に見合わないのでそこまではまあいいかなという手抜き
    const location = useLocation()
    useEffect(() => {
        refetch()
        // useFetchへの引数を渡すときにメモ化を行っていないのでrefetchを加えてはいけない
        // ちゃんとやるならuseFetchへの引数もメモ化するべきだが、他のところでもやっておらず作業が広範囲に及ぶ割にメモ化しておいた方がいいケースが珍しいので一旦このままでもよいかなという気持ち
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    return {
        count
    }
}
